export const orderStatusName = function(status) {
	let statusName = '';
	switch (status) {
		case 'Waiting delivery':
		statusName = "待发货";
		break;
		case 'Awaiting Payment':
		statusName = "待付款";
		break;
		case 'Canceled':
		statusName = "已取消";
		break;
		case 'On delivery':
		statusName = "已发货";
		break;
		case 'In operation':
		statusName = "生产中";
		break;

	}
	return statusName
};
export const refundStatusName = function(status) {
	let statusName = '';
	switch (status) {
		case 0:
			statusName = "待审核";
			break;
		case 1:
			statusName = "待客户寄回";
			break;
		case 2:
			statusName = "待厂家收货";
			break;
		case 4:
			statusName = "返修中";
			break;
		case 5:
			statusName = "待发货";
			break;
		case 6:
			statusName = "待客户收货";
			break;
		case 8:
			statusName = "已取消";
			break;
		case 9:
			statusName = "已完成";
			break;

	}
	return statusName
};

export const get_mtm_preference = function(type) {
	let statusName = '';
	type = Number(type)
	switch (type) {
		case 1:
		statusName = "标准版";
		break;
		case 2:
		statusName = "紧身版";
		break;
		case 3:
		statusName = "宽松版";
		break;
		case 4:
		statusName = "肥胖";
	}
	return statusName
}
export const get_mtm_measure_type = function(type) {
	let statusName = '';
	type = Number(type)
	switch (type) {
		case 1:
		statusName = "净体量尺";
		break;
		case 2:
		statusName = "成衣量尺";

	}
	return statusName
}

export const get_sex = function(type) {
	return type == 1 ? '男' : '女'
}

export const price_format = (value) => {
	return value ? (Math.round(value * 100) / 100).toFixed(2) : 0
}

export const print_type_text = function(type) {
	let text = '';
	type = Number(type)
	switch (type) {
		case 1:
			text = "压花";
			break;
		case 2:
			text = "绣花";
		case 3:
			text = "刺绣";
	}
	return text
}
